// extracted by mini-css-extract-plugin
export default {"global_bg":"App_global_bg__vclmY"};